import {
  CT2_FALLBACK, CT2_TABLE, CT3_FALLBACK, CT3_TABLE,
  CT6_FALLBACK, CT6_TABLE, CT7_CT9_FALLBACK, CT7_CT9_TABLE, lookupByWeight
} from './tables';
import { isElectric, normalizeVehicle } from './ev';

// An absent automatic rule means manual entry, never a confirmed zero liability.
export function hasAutomaticTaxRule(carType) {
  return ['CT1', 'CT2', 'CT3', 'CT12', 'CT13', 'CT17',
    'CT110', 'CT130', 'CT140', 'CT170', 'CT180'].includes(carType);
}

export function hasValidPositiveVehicleWeight(carWeight) {
  if (
    carWeight === null ||
    typeof carWeight === 'undefined' ||
    typeof carWeight === 'boolean' ||
    (typeof carWeight === 'string' && carWeight.trim() === '')
  ) {
    return false;
  }
  const numericWeight = Number(carWeight);
  return Number.isFinite(numericWeight) && numericWeight > 0;
}

// Yearly tax before late fees. Returns 6 prices: index 0 is the current-year tax;
// รย.1 (non-electric) also fills 1..5, the age-discounted rates for older cars.
// Vehicle types without a rule (e.g. CT900 อื่นๆ, CT15) return zeros.
export function calcBaseTaxPrices(vehicle) {
  const v = normalizeVehicle(vehicle.carType, vehicle.carFuel);
  const carType = v.carType;
  const weight = vehicle.carWeight;
  const engine = vehicle.engineSize;
  const electric = isElectric(v.carFuel);
  const prices = [0, 0, 0, 0, 0, 0];

  // Every EV requires weight before tax can be calculated. In particular, do
  // not let an absent value coerce to zero and enter the lowest weight tier.
  if (electric && !hasValidPositiveVehicleWeight(weight)) return prices;

  if (carType === 'CT12') {
    // Personal motorcycle: 100 baht flat, 50 baht if electric — a permanent,
    // separate base rate (confirmed by a DLT announcement), not a discount.
    prices[0] = electric ? 50 : 100;
  } else if (carType === 'CT3') {
    prices[0] = lookupByWeight(CT3_TABLE, CT3_FALLBACK, weight);
  } else if (carType === 'CT2' || (electric && carType === 'CT1')) {
    prices[0] = lookupByWeight(CT2_TABLE, CT2_FALLBACK, weight);
  } else if (carType === 'CT1') {
    let x;
    if (engine > 1800) {
      x = 2100 + (engine - 1800) * 4;
    } else if (engine > 600) {
      x = 300 + (engine - 600) * 1.5;
    } else {
      x = engine * 0.5;
    }
    for (let i = 0; i < 6; i++) {
      prices[i] = x - (x * i * 10) / 100;
    }
  } else if (carType === 'CT13') {
    prices[0] = 50;
  } else if (carType === 'CT110') {
    prices[0] = lookupByWeight(CT6_TABLE, CT6_FALLBACK, weight);
  } else if (carType === 'CT130' || carType === 'CT170') {
    prices[0] = lookupByWeight(CT7_CT9_TABLE, CT7_CT9_FALLBACK, weight);
  } else if (carType === 'CT140' || carType === 'CT180') {
    prices[0] = lookupByWeight(CT2_TABLE, CT2_FALLBACK, weight);
  } else if (carType === 'CT17') {
    // Public/for-hire motorcycle (รถจักรยานยนต์รับจ้าง): 100 baht flat whether petrol
    // or electric — there is no lower EV rate for this type.
    prices[0] = 100;
  }

  return prices;
}
